import React, { useState } from 'react';
import { Box, Breadcrumbs, Card, CardContent, Link, Tab, Tabs, Typography } from '@mui/material';
import MainLayout from '../../components/layout/MainLayout';
import ActiveAppsTab from '../../components/admin/twiml/ActiveAppsTab';
import LiveCallsTab from '../../components/admin/twiml/LiveCallsTab';
import IvrFlowsTab from '../../components/admin/twiml/IvrFlowsTab';
import AcdQueuesTab from '../../components/admin/twiml/AcdQueuesTab';
import VoiceLogsTab from '../../components/admin/twiml/VoiceLogsTab';
import VoiceTestConsoleTab from '../../components/admin/twiml/VoiceTestConsoleTab';

const VoiceDashboardPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <MainLayout>
      <Box sx={{ p: 2 }}>
        <Box sx={{ mb: 1 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" href="#">Admin</Link>
            <Typography color="text.primary">TwiML Dashboard</Typography>
          </Breadcrumbs>
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>TwiML Dashboard</Typography>

        <Tabs value={tab} onChange={(e, v) => setTab(v)} aria-label="TwiML dashboard tabs" variant="scrollable" allowScrollButtonsMobile>
          <Tab label="Active Apps" />
          <Tab label="Live Calls" />
          <Tab label="IVR Flows" />
          <Tab label="ACD Queues" />
          <Tab label="Logs" />
          <Tab label="Voice Test Console" />
        </Tabs>

        <Card variant="outlined" sx={{ mt: 2 }}>
          <CardContent>
            {tab === 0 && <ActiveAppsTab />}
            {tab === 1 && <LiveCallsTab />}
            {tab === 2 && <IvrFlowsTab />}
            {tab === 3 && <AcdQueuesTab />}
            {tab === 4 && <VoiceLogsTab />}
            {tab === 5 && <VoiceTestConsoleTab />}
          </CardContent>
        </Card>
      </Box>
    </MainLayout>
  );
};

export default VoiceDashboardPage;
